// Script to automatically populate localStorage with master assets data
// This script should be included in the application to run on startup

(function() {
    try {
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || !window.localStorage) {
            console.log('Not in browser environment, skipping auto-population');
            return;
        }

        // Check if assets are already populated
        const existingAssets = localStorage.getItem('bme-assets');
        const lastUpdated = localStorage.getItem('bme-assets-last-updated');

        // If we have recent data (less than 1 day old), don't repopulate
        if (existingAssets && lastUpdated) {
            const lastUpdateDate = new Date(lastUpdated);
            const now = new Date();
            const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

            if (!Number.isNaN(lastUpdateDate.getTime()) && (now - lastUpdateDate < oneDay)) {
                console.log('Assets are recent, skipping auto-population');
                return;
            }
        }

        // If no assets or old data, populate with master data
        console.log('Auto-populating master assets data...');

        // Fetch the master assets data
        fetch('master_assets_fully_enhanced.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(assets => {
                // Save to localStorage
                localStorage.setItem('bme-assets', JSON.stringify(assets));
                localStorage.setItem('bme-assets-last-updated', new Date().toISOString());
                console.log(`Successfully populated ${assets.length} assets to localStorage!`);

                // Dispatch a custom event to notify the application
                window.dispatchEvent(new CustomEvent('assetsPopulated', {
                    detail: { count: assets.length }
                }));
            })
            .catch(error => {
                console.error('Error auto-populating assets:', error);

                // If fetch fails, try to load from a fallback source
                console.log('Trying fallback asset population...');
                populateFallbackAssets();
            });
    } catch (error) {
        console.error('Auto-populate initialization failed safely:', error);
    }
})();

// Fallback function to populate sample assets if fetch fails
function populateFallbackAssets() {
    try {
        // Sample assets data
        const sampleAssets = [
            {
                "id": "sample-1",
                "assetId": "A001",
                "serialNo": "SN-789456",
                "floor": "Ground Floor",
                "department": "Radiology",
                "equipmentName": "X-Ray Machine",
                "manufacturer": "MedTech Solutions",
                "model": "XR-2000",
                "installationDate": "01-Jan-2020",
                "pmDue": "01-Jan-2025",
                "pmDone": "01-Jan-2024",
                "calDue": "01-Jul-2025",
                "calDone": "01-Jul-2024",
                "trainingDue": "01-Oct-2024", // Added training field
                "trainingDone": "01-Oct-2023", // Added training field
                "trainingType": "Operation", // Added training field
                "trainingProvider": "Medskills", // Added training field
                "certificateNumber": "TC-2024-001", // Added training field
                "type": "Diagnostic"
            },
            {
                "id": "sample-2",
                "assetId": "A002",
                "serialNo": "SN-123456",
                "floor": "First Floor",
                "department": "Cardiology",
                "equipmentName": "ECG Machine",
                "manufacturer": "CardioSystems Inc",
                "model": "ECG-1000",
                "installationDate": "15-Feb-2019",
                "pmDue": "15-Feb-2024",
                "pmDone": "15-Feb-2023",
                "calDue": "15-Aug-2024",
                "calDone": "15-Aug-2023",
                "trainingDue": "15-Nov-2023", // Added training field
                "trainingDone": "15-Nov-2022", // Added training field
                "trainingType": "Maintenance", // Added training field
                "trainingProvider": "Medtech Solutions", // Added training field
                "certificateNumber": "TC-2023-002", // Added training field
                "type": "Monitoring"
            },
            {
                "id": "sample-3",
                "assetId": "A003",
                "serialNo": "SN-789123",
                "floor": "Second Floor",
                "department": "Laboratory",
                "equipmentName": "Centrifuge",
                "manufacturer": "LabTech Corp",
                "model": "CF-500",
                "installationDate": "10-Mar-2021",
                "pmDue": "10-Mar-2026",
                "pmDone": "10-Mar-2025",
                "calDue": "10-Sep-2026",
                "calDone": "10-Sep-2025",
                "trainingDue": "10-Dec-2025", // Added training field
                "trainingDone": "10-Dec-2024", // Added training field
                "trainingType": "Safety", // Added training field
                "trainingProvider": "Zydus Training", // Added training field
                "certificateNumber": "TC-2025-003", // Added training field
                "type": "Laboratory"
            }
        ];
        
        localStorage.setItem('bme-assets', JSON.stringify(sampleAssets));
        localStorage.setItem('bme-assets-last-updated', new Date().toISOString());
        console.log(`Successfully populated ${sampleAssets.length} sample assets to localStorage!`);
        
        // Dispatch a custom event to notify the application
        window.dispatchEvent(new CustomEvent('assetsPopulated', {
            detail: { count: sampleAssets.length, isSample: true }
        }));
    } catch (error) {
        console.error('Error populating fallback assets:', error);
    }
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { populateFallbackAssets };
}